import { useEffect } from "react";

/**
 * SAYFA KAYDIRMA KİLİDİ — TEK SAHİP, REF SAYAÇLI.
 *
 * ── Neden bu dosya var ──
 * Kilidi iki ayrı bileşen (Drawer yığını ve dosya önizleme modali) birbirinden habersiz,
 * naif "önceki değeri sakla → geri yükle" deseniyle yönetiyordu:
 *
 *     const prev = document.body.style.overflow;
 *     document.body.style.overflow = "hidden";
 *     return () => { document.body.style.overflow = prev; };
 *
 * İki sahip iç içe girdiğinde bu desen KALICI KİLİT bırakır:
 *   1. Drawer açılır      → prev = ""       , body = "hidden"
 *   2. Önizleme açılır    → prev = "hidden" , body = "hidden"
 *   3. Drawer sayısı değişir (effect yeniden koşar) → temizlik body = "" yapar
 *   4. Önizleme kapanır   → kendi prev'ini ("hidden") geri yükler → SAYFA BİR DAHA KAYDIRILAMAZ
 *
 * Çözüm: kilidi tek bir modül tutar, sahip sayısını sayar. İlk sahip kilitler, SON sahip
 * çözer; aradaki açma/kapamalar sayaçtan ibarettir. Orijinal değer yalnız BİR KEZ,
 * ilk kilitte saklanır.
 *
 * Çoklu sekme geldiğinde bu ön koşul: iki farklı sekmenin overlay'leri aynı anda yaşayacağı
 * için yukarıdaki 4 adımlı sıra kural dışı değil, OLAĞAN hâle gelir.
 */

let owners = 0;
let saved: string | null = null;

/** Kilidi al. Dönen fonksiyon SERBEST BIRAKIR ve yalnız bir kez etki eder. */
export function acquireScrollLock(): () => void {
  if (owners === 0) {
    saved = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  owners += 1;
  let released = false;
  return () => {
    // İki kez çağrılırsa (React StrictMode çift-invoke, hatalı temizlik) sayaç bozulmasın.
    if (released) return;
    released = true;
    owners -= 1;
    if (owners === 0) {
      document.body.style.overflow = saved ?? "";
      saved = null;
    }
  };
}

/** `active` true olduğu sürece sayfa kaydırması kilitli. */
export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    return acquireScrollLock();
  }, [active]);
}
